import { render, staticRenderFns } from "./Cascade.vue?vue&type=template&id=cd13153a&scoped=true"
import script from "./Cascade.vue?vue&type=script&lang=js"
export * from "./Cascade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13153a",
  null
  
)

export default component.exports